import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import axios from 'axios';
import QRModal from './QRModal';

const baseUrl = import.meta.env.VITE_API_URL;
const AppUrl = import.meta.env.VITE_APPLICATION_URL;
const socket = io(`${baseUrl}`);

interface SessionData {
  sessionId: string;
  qrCode: string;
}

interface ImageData {
  filename: string;
  buffer: string;
  mimetype: string;
}

const Desktop: React.FC = () => {
  const [session, setSession] = useState<SessionData | null>(null);
  const [qrOpen, setQrOpen] = useState(false);
  const [image, setImage] = useState<string | null>(null);  
  const generateSession = async () => {
    const { data } = await axios.get<SessionData>(`${baseUrl}/generate-session`);
    setSession(data);
    setQrOpen(true);
    socket.emit('register', { sessionId: data.sessionId, client: 'desktop' });
  };

  useEffect(() => {
    socket.on('image-uploaded', (data: ImageData) => {
      setImage(`data:${data.mimetype};base64,${data.buffer}`);
      setQrOpen(false);
    });

    return () => {
      socket.off('image-uploaded');
    };
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: 50, height: '100vh' }}>
      <h1>Upload From Phone</h1>
      <button onClick={generateSession}>Upload from Phone</button>
      {qrOpen && session && <QRModal sessionId= {`${AppUrl}/mobile-upload/${session.sessionId}`} />}
      {image && <img src={image} alt="Uploaded" style={{ marginTop: 20, maxWidth: 400 }} />}
    </div>
  );
};

export default Desktop;
